<template>
  <div id="not-found" class="content md-layout md-gutter md-alignment-center-center">
    <div class="md-layout-item">
      <md-empty-state
        md-icon="error_outline"
        md-label="Page not Found!"
        md-description="The page you are looking for was not found.">
      </md-empty-state>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PageNotFound',
  title: 'Fabrício Ceschin - Page not Found',
  props: {
    // msg: String,
    // num: Number
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#not-found {
  text-align:center;
  padding-bottom:15px;
}
</style>
